import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import paths from 'commons/paths';
import { useMyPage } from 'hooks';
import { MyBookstoreBoardTable } from '../../pages/MyPage/Community/BookstoreBoard';

const BOARD_COUNT_TO_SHOW = 5;

const BookstoreBoardSection = () => {
  // 고객 요청 사항으로 독서 챌린지 오픈 (2026. 01. 06)
  const { bookstoreBoards, bookstoreBoardsIsValidating, setPage } = useMyPage({});

  useEffect(() => {
    setPage('1');
  }, []);

  if (bookstoreBoardsIsValidating) return <></>;

  return (
    <div className="mypage_section">
      <div className="mypage_inner">
        <div className="mypage_top">
          <h3 className="mypage_top_title">작성한 게시글 - 독서 챌린지</h3>
          {(bookstoreBoards?.totalAmount as number) > BOARD_COUNT_TO_SHOW ? (
            <Link to={`${paths.getPath('myBookstoreBoard')}`} className="mypage_top_link">
              모두 보기
            </Link>
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className="mypage_board list_table">
        <MyBookstoreBoardTable
          list={bookstoreBoards?.bookstoreBoardList || []}
          count={bookstoreBoards?.totalAmount as number}
          limit={BOARD_COUNT_TO_SHOW}
          ga_belong="마이페이지/작성한 게시글 - 독서 챌린지"
        />
      </div>
    </div>
  );
};

export default BookstoreBoardSection;
